import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-362c41e3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gutter--sm" }
const _hoisted_2 = {
  key: 0,
  class: "row pb-1 pt-1"
}
const _hoisted_3 = { class: "flex xs2" }
const _hoisted_4 = { class: "flex xs1 float-right" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = {
  key: 1,
  class: "pt-3"
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" Welcome to Crypto Notifi! You have not created any Favorites yet. Go to the ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("Protocols Section")
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" and select those you have positions in to get started. ")

import Moralis from "moralis";
import { computed, ref, onMounted } from "vue";
import ProtocolInfo from "@/components/ProtocolInfo.vue";
import { Protocol } from "@/models/Protocol";
import { useUserStore } from "@/store/pinia_user";

/* global defineProps, defineEmits */

export default /*#__PURE__*/_defineComponent({
  props: {
  showAdd: { type: Boolean, required: false, default: false },
},
  setup(__props) {

const props = __props



const userStore = useUserStore();

const rawProtocols = ref<Protocol[]>([]);
const intSearch = ref("");
const favorites = ref(true);
const queryLimit = ref(25);
const protocolsLoading = ref(false);
const rawCount = ref(0);

const showNoPositions = computed(() => {
  return rawCount.value == 0 && !protocolsLoading.value;
});

onMounted(async () => {
  fetchProtocols();
});

const protocols = computed((): Protocol[] => {
  let prots = rawProtocols.value;
  return prots;
});

const search = computed({
  get(): string {
    return intSearch.value;
  },
  set(newVal: string) {
    intSearch.value = newVal;
    rawProtocols.value.length = 0;
    fetchProtocols();
  },
});

const edit = (id: string): void => {
  console.log(`Edit ${id}`);
};

const remove = (id: string): void => {
  console.log(`remove ${id}`);
  const query = new Moralis.Query("Subscription");
  query.get(id).then((s: { destroy: () => Promise<unknown> }) => {
    s.destroy().then((oldS) => {
      console.log(`Success remove ${oldS}`);
    });
  });
};

const refresh = () => {
  rawProtocols.value.length = 0;
  fetchProtocols();
};

const appendProtocols = async (): Promise<void> => {
  fetchProtocols();
};

const fetchProtocols = async (): Promise<void> => {
  if (!userStore.user) return;
  protocolsLoading.value = true;
  const rel = userStore.user.relation("FavoriteProtocols");
  const query = rel.query();
  rawCount.value = await query.count();
  if (search.value) {
    query.matches("name", search.value);
  }
  query.limit(queryLimit.value);
  query.skip(rawProtocols.value.length);
  let subs = await query.find();
  subscribe(query);
  rawProtocols.value.push(...subs);
  protocolsLoading.value = false;
};

const subscribe = async (query: any) => {
  const subscription = await query.subscribe();
  subscription.on("create", (sub: Protocol) => {
    rawProtocols.value.push(sub);
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subscription.on("update", (sub: Protocol) => {
    const index = rawProtocols.value.findIndex((e) => e.id == sub.id);
    if (index > -1) {
      rawProtocols.value.splice(index, 1, sub);
    }
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subscription.on("enter", (sub: Protocol) => {
    console.log("Positions - Protocols object entered");
    rawProtocols.value.push(sub);
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subscription.on("leave", (sub: Protocol) => {
    console.log("Positions - Protocols object left");
    const index = rawProtocols.value.findIndex((e) => e.id == sub.id);
    if (index > -1) {
      rawProtocols.value.splice(index, 1);
    }
  });
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  subscription.on("delete", (sub: Protocol) => {
    const index = rawProtocols.value.findIndex((e) => e.id == sub.id);
    if (index > -1) {
      rawProtocols.value.splice(index, 1);
    }
  });
  subscription.on("close", () => {
    console.log("Protocols subscription closed");
  });
};

return (_ctx: any,_cache: any) => {
  const _component_va_input = _resolveComponent("va-input")!
  const _component_va_checkbox = _resolveComponent("va-checkbox")!
  const _component_va_button = _resolveComponent("va-button")!
  const _component_va_inner_loading = _resolveComponent("va-inner-loading")!
  const _component_va_chip = _resolveComponent("va-chip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_unref(showNoPositions))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_va_input, {
            class: "flex xs7",
            label: "Search Names",
            modelValue: _unref(search),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(search) ? (search).value = $event : null))
          }, null, 8, ["modelValue"]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_va_checkbox, {
              modelValue: favorites.value,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((favorites).value = $event)),
              label: "Favorites?",
              disabled: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_va_button, {
              icon: "refresh",
              color: "secondary",
              onClick: refresh
            })
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_va_inner_loading, {
      loading: protocolsLoading.value,
      size: 60
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(protocols), (protocol) => {
            return (_openBlock(), _createBlock(ProtocolInfo, {
              key: protocol.id,
              allowSelect: false,
              protocol: protocol,
              displayMode: "wide",
              showPositions: true
            }, null, 8, ["protocol"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 8, ["loading"]),
    (_unref(showNoPositions))
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("h2", null, [
            _hoisted_7,
            _createVNode(_component_va_chip, { to: "/protocols" }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            }),
            _hoisted_9
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})